var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNotificationBing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.77V6.44c0-.41.34-.75.75-.75s.75.34.75.75v3.33a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42 19.12c-.91-.3-1.6-.95-1.9-1.77-.3-.82-.2-1.76.29-2.58l1.27-2.12c.28-.47.53-1.35.53-1.9v-2.1c0-4.09 3.32-7.41 7.41-7.41s7.41 3.32 7.41 7.41v2.1c0 .54.25 1.43.53 1.9l1.27 2.12c.47.78.55 1.71.24 2.56-.31.85-.99 1.5-1.85 1.79-2.45.83-5.02 1.23-7.6 1.23s-5.15-.41-7.6-1.23zM6.11 8.66v2.1c0 .81-.32 1.98-.74 2.67L4.1 15.56c-.26.43-.32.89-.17 1.29s.49.7.97.86c4.6 1.53 9.66 1.53 14.26 0 .43-.14.76-.46.91-.88.16-.42.11-.88-.12-1.27l-1.27-2.12c-.42-.69-.74-1.86-.74-2.67v-2.1c-.01-3.27-2.66-5.92-5.92-5.92S6.11 5.4 6.11 8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12 21.7c-.76-.76-1.2-1.81-1.2-2.88h1.5c0 .68.28 1.34.76 1.82s1.14.76 1.82.76c1.42 0 2.58-1.16 2.58-2.58h1.5c0 2.25-1.83 4.08-4.08 4.08-1.07 0-2.12-.44-2.88-1.2z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNotificationBing);
export default __webpack_public_path__ + "static/media/vuesax-outline-notification-bing.bebfbc9b28c5467419aa47a0712b2061.svg";
export { ForwardRef as ReactComponent };